export const PRODUCT_SLUGS = {
  console: 'console',
  event_gateway: 'event_gateway',
  outpost: 'outpost',
} as const;

export type ProductSlug = keyof typeof PRODUCT_SLUGS;
